'use strict';
var novicell = novicell || {};

novicell.search = novicell.search || function () {

    function init() {
        site_search();
    }

    function site_search() {
        var search_toggle = document.getElementById('input-toggle__site-search'),
            nav_toogle = document.getElementById('input-toggle__site-nav'),
            site_overlay = document.getElementById('js-site-overlay'),
            site_content = document.getElementById('site-content');

        search_toggle.addEventListener('change', function(event) {
            event.stopPropagation();

            var checkbox = event.target,
                search_input = document.querySelector('.site-search-form__input');

            if (nav_toogle.checked) {
                nav_toogle.checked = false;
            }

            if (checkbox.checked) {
                search_input.focus();
                
                ( document.documentElement )
                    ? document.documentElement.classList.add('no-scroll')
                    : document.body.classList.add('no-scroll');

                bodyScrollLock.clearAllBodyScrollLocks();
                bodyScrollLock.disableBodyScroll(site_content);

                site_overlay.addEventListener('click', function(e) {
                    e.stopPropagation;

                    search_toggle.checked = false;

                    ( document.documentElement )
                        ? document.documentElement.classList.remove('no-scroll')
                        : document.body.classList.remove('no-scroll');

                    bodyScrollLock.enableBodyScroll(site_content);
                });
                
            } else {
                ( document.documentElement )
                    ? document.documentElement.classList.remove('no-scroll')
                    : document.body.classList.remove('no-scroll');

                bodyScrollLock.clearAllBodyScrollLocks();
            }
        });
    }

    return {
        init : init,
        site_search : site_search
    };

}();